import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  LeftSidebarView,
} from 'components/Sidebar'
import InfiniteScroll from 'components/InfiniteScroll'
import Bookmark from './components/Bookmark'

export class Bookmarks extends React.Component {
  static propTypes = {
    isLoaded: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    lastLoadedTimestamp: PropTypes.number,
    currentUser: PropTypes.object.isRequired,
    bookmarks: PropTypes.array.isRequired,

    fetchBookmarks: PropTypes.func.isRequired,
    requestRemoveBookmark: PropTypes.func.isRequired,
  }

  handleLoadMore = () => {
    const { lastLoadedTimestamp, fetchBookmarks } = this.props

    fetchBookmarks({
      lastLoadedTimestamp
    })
  }

  handleRemoveBookmark = (id) => {

    this.props.requestRemoveBookmark({ id })
  }

  render () {
    const {
      isLoaded,
      isLoading,
      currentUser,
      bookmarks
    } = this.props

    return (
      <LeftSidebarView
        title={<FormattedMessage id='BOOKMARKS' />}
      >
        <InfiniteScroll
          isLoading={isLoading}
          isLoaded={isLoaded}
          onLoadMore={this.handleLoadMore}
        >
          {bookmarks.map(bookmark =>
            <Bookmark
              key={bookmark.id}
              id={bookmark.id}
              activityGroup={bookmark.activityGroup}
              currentUser={currentUser}
              onRemoveBookmark={this.handleRemoveBookmark}
            />
          )}
        </InfiniteScroll>
      </LeftSidebarView>
    )
  }
}

export default Bookmarks
